module.exports = _cInfo;


/*****************
 ** WEBPACK FOOTER
 ** external "_cInfo"
 ** module id = 484
 ** module chunks = 0
 **/